import {
  Autocomplete,
  Backdrop,
  Button,
  Grid,
  IconButton,
  TextField,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import Card from "../../StyledComponents/Card/Card";
import CardHeader from "../../StyledComponents/Card/CardHeader";
import CardText from "../../StyledComponents/Card/CardText";
import CardBody from "../../StyledComponents/Card/CardBody";
import React, { useEffect, useState } from "react";

import { ArrowBack } from "@material-ui/icons";
import { useNavigate } from "react-router-dom";
import { dashboardStyle } from "../Invoices/Components/InvoiceDetails/style";
import { useDispatch, useSelector } from "react-redux";
import { Role } from "../../Redux/Actions/Role";
import moment from "moment";
import { formatDateTimeForBackend } from "../../Functions";

import isFutureDate from "../../Functions/isFutureDate";
import isValidatedDate from "../../Functions/isValidatedDate";
import { createNewInvoice, getVendorDetail } from "../Invoices/actions";
import isOldDateValidate from "../../Functions/isOldDateValidate";
import ProceedBtn from "../Invoices/NewInvoice/InvoiceGuidLines/proceedbtn";
import { Error } from "@mui/icons-material";
// import { MATURITY_PERIOD } from "../../enums/MATURITY_PERIOD";
import CustomSnackbar from "../../CustomSnackbar";
import { createNewLC, getBankDetail } from "./actions";

const useStyles = makeStyles(dashboardStyle);

const NewLc = () => {
  const [dragloader, setDragLoader] = useState(false);
  const [vendors, setVendors] = useState([]);
  const [bankDetails, setBankDetails] = useState([]);
  const [pageLoader, setPageLoader] = useState(false);
  const [Post, setPost] = useState(true);
  const [confirmationMessage, setConfirmationMessage] = useState("");
  const [vendorLoading, setVendorLoading] = useState(false);
  const [bankDetailsLoading, setBankDetailsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const [successMessage, setSuccessMessage] = useState("");
  const [statusForPayload, setStatusForPayload] = useState("");
  const [lcs, setLcs] = useState([
    {
      roleId: "6bc20e5d-4881-4365-8897-97c79a0763e2",
      roleName: "I2P Initiator",
    },
    {
      roleId: "b5f43efb-f59b-4378-bc3a-586ee4ee7346",
      roleName: "IR",
    },
    {
      roleId: "c57255c1-49a1-46e1-b492-b20f5ccd71dd",
      roleName: "EFDV Initiator",
    },
    {
      roleId: "0f75036f-a26e-4176-b18a-7cbae96a51cc",
      roleName: "HR",
    },
    {
      roleId: "3a662fad-f1b0-499c-a33d-bd6dd94d96f2",
      roleName: "Department Coordinator",
    },
  ]);
  const [lcsLoading, setLcsLoading] = useState(false);
  const [selectedRole, setSelectedRole] = useState("");
  const [lc_Amount_formatted, setLC_Amount_formatted] = useState(0);
  const [openInvalidWarningDate, setOpenInvalidWarningDate] = useState(false);
  const [InvalidWarningDateState, setInvalidWarningDateState] = useState("");
  const [openProceedBtn, setOpenProceedBtn] = useState(false);
  const state = useSelector((state) => state.Role);
  const [formState, setFormState] = useState({
    issuance_date: "",
    expiry_date: "",
    isProceed: true,
    isDelete: false,
    lc_id: 0,
  });
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    getVendorDetail(null, setVendors, setVendorLoading);
  }, [formState?.Vendor?.Vendor_Code]);
  useEffect(() => {
    getBankDetail(null, setBankDetails, setBankDetailsLoading);
  }, []);
  
  // UPDATED: Added LC Amount validation
  const submitHandler = (e) => {
    e.preventDefault();
    
    // Validate LC Amount
    const lcAmount = parseFloat(formState?.lc_amount || 0);
    
    if (!formState?.lc_amount || lcAmount <= 0) {
      setErrorMessage("LC Amount must be greater than 0");
      return;
    }
    
    // Clear any previous error messages
    setErrorMessage("");
    setOpenProceedBtn(true);
  };

  const maturityPeriods = [
    {
      name: "90",
      value: "90",
    },
    {
      name: "120",
      value: "120",
    },
    {
      name: "180",
      value: "180",
    },
  ];
  const confirmNewLcCreation = () => {
    const newFormState = {
      bank_Id: formState?.bank_Name?.bank_Id,
      lC_Amount: formState?.lc_amount,
      vendor_Code: formState?.Vendor?.Vendor_Code,
      issuance_Date: formState?.issuance_date,
      expiry_Date: formState?.expiry_date,
      maturity_Period: formState?.maturityPeriod?.value,
      lC_Bank_Reference_num: formState?.lC_Bank_Reference_num,
      available_Amount : formState?.lc_amount
    };

    createNewLC(
      newFormState,
      setFormState,
      setErrorMessage,
      setSuccessMessage,
      setOpenProceedBtn
    );
  };

  const changeHandler = (e) => {
    const { name, value } = e.target;
    if (name === "lc_amount") {
      let cleanedValue = value.replace(/[^\d.]/g, "");
      const decimalIndex = cleanedValue.indexOf(".");
      if (decimalIndex !== -1) {
        cleanedValue = cleanedValue.substring(0, decimalIndex + 4);
      }
      if (/^\d*\.?\d*$/.test(cleanedValue) || cleanedValue === "") {
        // Apply formatting logic for integers and decimals
        const formattedValue =
          cleanedValue === ""
            ? cleanedValue
            : cleanedValue.replace(/\B(?=(\d{3})+(?!\d))/g, ","); // Add commas for thousands

        setFormState((prevState) => ({
          ...prevState,
          [name]: cleanedValue,
          [`${name}_formatted`]: formattedValue,
          // [name]: formattedValue,
        }));
        setLC_Amount_formatted(formattedValue);
        
        // Clear error message when user starts typing a valid amount
        if (parseFloat(cleanedValue) > 0) {
          setErrorMessage("");
        }
      }
    }

    if (name === "issuance_date") {
      isFutureDate(
        formatDateTimeForBackend(value),
        setFormState,
        "issuance_date"
      );
      isValidatedDate(
        formatDateTimeForBackend(formState?.expiry_date),
        value,
        setFormState,
        "expiry_date"
      );
    }

    if (name === "expiry_date") {
      isValidatedDate(
        formatDateTimeForBackend(value),
        formState?.issuance_date,
        setFormState,
        "expiry_date"
      );
    }

    if (name === "maturityPeriod" || name === "lC_Bank_Reference_num") {
      setFormState((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  const autocompleteChangeHandler = (name, value) => {
    setFormState((formState) => ({
      ...formState,
      [name]: value,
    }));
  };

  useEffect(() => {
    successMessage &&
      setTimeout(() => {
        navigate("/vendorfinancingLC");
      }, [1500]);
  }, [successMessage]);

  const classes = useStyles();
  return (
    <Card>
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={dragloader || pageLoader}></Backdrop>
      <CardHeader text>
        <CardText
          style={{
            color: "white",
            backgroundColor: "#031C30",
            padding: "0px 27px",
          }}>
          <Grid container justifyContent="space-between">
            <Grid item xs={2} sm={3} md={3} lg={6} mt={1}>
              <h1 style={{ fontSize: "20px" }}>New Lc</h1>
            </Grid>
            <Grid item xs={6} sm={6} md={6} lg={6}>
              <IconButton
                variant="contained"
                style={{
                  float: "right",
                  alignItems: "center",
                  margin: "18.760px 0px",
                }}
                onClick={() => navigate("/vendorfinancingLC")}>
                <ArrowBack style={{ color: "#fff" }} titleAccess="Go Back" />
              </IconButton>
            </Grid>
          </Grid>
        </CardText>
      </CardHeader>
      <CardBody>
        <form onSubmit={(e) => submitHandler(e)}>
          {/* Check boxes */}
          <Grid container spacing={1}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Grid
                container
                spacing={1}
                style={{ marginTop: "2px" }}
                alignItems="center">
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <Grid
                    container
                    rowSpacing={1}
                    columnSpacing={1}
                    style={{ marginTop: "2px" }}>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                      <Typography className={classes.text}>
                        <span className={classes.asterisk}>*</span>
                        Select Bank Name
                      </Typography>
                      <Autocomplete
                        sx={{
                          "& .MuiInputBase-root": {
                            height: "30px",
                            textAlign: "center",
                            display: "flex",
                            alignItems: "center",
                          },
                          "& .MuiInputBase-input": {
                            marginTop: "-4px", // Adjust this value to move the text up
                            fontSize: 15,
                          },
                        }}
                        id="bank_Name"
                        options={bankDetails}
                        classes={{ option: classes.option }}
                        size="small"
                        name="bank_Name"
                        value={formState["bank_Name"]}
                        getOptionLabel={(option) =>
                          (option !== "" && `${`${option?.bank_Name}`}`) || ""
                        }
                        loading={bankDetailsLoading}
                        onChange={(event, newValue) => {
                          autocompleteChangeHandler("bank_Name", newValue);
                        }}
                        renderInput={(params) => (
                          <TextField
                            // sx={{ input: { color: "#888888" } }}
                            {...params}
                            name=""
                            required
                            value={""}
                            onChange={(event) => {
                              getBankDetail(
                                event.target.value,
                                setBankDetails,
                                setBankDetailsLoading
                              );
                            }}
                            InputProps={{
                              ...params.InputProps,
                              endAdornment: (
                                <React.Fragment>
                                  {params.InputProps.endAdornment}
                                </React.Fragment>
                              ),
                            }}
                          />
                        )}
                      />
                    </Grid>

                    <Grid item xs={12} sm={12} md={6} lg={6}>
                      <Typography className={classes.text}>
                        <span className={classes.asterisk}>*</span>
                        LC/ Bank Reference no
                      </Typography>
                      <TextField
                        type="text"
                        required={formState?.isProceed}
                        onChange={changeHandler}
                        value={formState?.lC_Bank_Reference_num}
                        fullWidth
                        size="small"
                        sx={{
                          "& .MuiInputBase-root": {
                            height: 30,
                          },
                          "& legend": { display: "none" },
                          "& fieldset": { top: 0 },
                        }}
                        variant="outlined"
                        name="lC_Bank_Reference_num"
                        id="lC_Bank_Reference_num"></TextField>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                      <Typography className={classes.text}>
                        <span className={classes.asterisk}>*</span>
                        LC Amount
                      </Typography>
                      <TextField
                        fullWidth
                        required={formState?.isProceed}
                        size="small"
                        sx={{
                          "& .MuiInputBase-root": {
                            height: 30,
                          },
                          "& legend": { display: "none" },
                          "& fieldset": { top: 0 },
                        }}
                        id="outlined-basic"
                        variant="outlined"
                        type="text"
                        pattern="[0-9]*"
                        min={1}
                        value={lc_Amount_formatted}
                        error={formState?.lc_amount && parseFloat(formState?.lc_amount) <= 0}
                        helperText={
                          formState?.lc_amount && parseFloat(formState?.lc_amount) <= 0
                            ? "Amount must be greater than 0"
                            : ""
                        }
                        InputProps={{
                          inputProps: {
                            min: 1,
                            step: "0.00000000000000001",
                            inputMode: "numeric",
                          },
                        }}
                        onChange={changeHandler}
                        name="lc_amount"
                      />
                    </Grid>

                    <Grid item xs={12} sm={12} md={6} lg={6}>
                      <Typography className={classes.text}>
                        <span className={classes.asterisk}>*</span>
                        Select Vendor
                      </Typography>
                      <Autocomplete
                        sx={{
                          "& .MuiInputBase-root": {
                            height: "30px",
                            textAlign: "center",
                            display: "flex",
                            alignItems: "center",
                          },
                          "& .MuiInputBase-input": {
                            marginTop: "-4px", // Adjust this value to move the text up
                            fontSize: 15,
                          },
                        }}
                        id="Vendor"
                        options={vendors}
                        classes={{ option: classes.option }}
                        size="small"
                        name="Vendor"
                        value={formState.Vendor}
                     
                     
                        getOptionLabel={(option) => {
                          const isBlocked = option?.ALL_COMPANY_CODE === "X";
                         
                          return (option !== "" &&
                            `${
                              option?.Vendor_Code !== "-1"
                                ? `${option?.Vendor_Code}-`
                                : ""
                            }${option?.Vendor_Name} ${isBlocked ? "(Blocked)" : ""}`) ||
                          ""
                        }
                         
                        }
                        loading={vendorLoading}
                        onChange={(event, newValue) => {
                          autocompleteChangeHandler("Vendor", newValue);
                        }}
                        renderInput={(params) => (
                          <TextField
                            // sx={{ input: { color: "#888888" } }}
                            {...params}
                            name=""
                            required
                            value={""}
                            onChange={(event) => {
                              getVendorDetail(
                                event.target.value,
                                setVendors,
                                setVendorLoading
                              );
                            }}
                            InputProps={{
                              ...params.InputProps,
                              endAdornment: (
                                <React.Fragment>
                                  {params.InputProps.endAdornment}
                                </React.Fragment>
                              ),
                            }}
                          />
                        )}
                      />
                    </Grid>

                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={6}
                      lg={6}
                      style={{ paddingRight: "18px" }}>
                      <Typography className={classes.text}>
                        <span className={classes.asterisk}>*</span>
                        Issuance Date{" "}
                      </Typography>

                      <input
                        className={classes.inputField}
                        name="issuance_date"
                        sx={{
                          "& .MuiInputBase-root": {
                            height: 30,
                          },
                          "& legend": { display: "none" },
                          "& fieldset": { top: 0 },
                        }}
                        type="date"
                        max="9999-12-31"
                        size="small"
                        onChange={changeHandler}
                        value={formState.issuance_date || ""}
                        onInput={(newValue) => {
                          setFormState((formState) => ({
                            ...formState,
                            issuance_date: formatDateTimeForBackend(newValue),
                          }));
                          isFutureDate(
                            formatDateTimeForBackend(newValue),
                            setFormState,
                            "issuance_date"
                          );
                        }}
                        // disabled={disable}
                        style={{
                          height: 13, // Adjust this value to decrease the height
                        }}
                        required={formState?.isProceed}
                      />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={6}
                      lg={6}
                      style={{ paddingRight: "18px" }}>
                      <Typography className={classes.text}>
                        <span className={classes.asterisk}>*</span>
                        Expiry Date
                      </Typography>
                      <input
                        className={classes.inputField}
                        name="expiry_date"
                        sx={{
                          "& .MuiInputBase-root": {
                            height: 30,
                          },
                          "& legend": { display: "none" },
                          "& fieldset": { top: 0 },
                        }}
                        type="date"
                        // max="9999-12-31"
                        onChange={changeHandler}
                        onInput={(newValue) => {
                          formatDateTimeForBackend(newValue);
                          setFormState((formState) => ({
                            ...formState,
                            expiry_date: formatDateTimeForBackend(newValue),
                          }));
                          isValidatedDate(
                            formatDateTimeForBackend(newValue),
                            formState?.issuance_date,
                            setFormState,
                            "expiry_date"
                          );
                        }}
                        // disabled={disable}
                        style={{
                          height: 13, // Adjust this value to decrease the height
                        }}
                        required={formState?.isProceed}
                        value={formState.expiry_date || ""}
                        size="small"
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                      <Typography className={classes.text}>
                        <span className={classes.asterisk}>*</span>
                        Maturity Period
                      </Typography>

                      <Autocomplete
                        sx={{
                          "& .MuiInputBase-root": {
                            height: "30px",
                            textAlign: "center",
                            display: "flex",
                            alignItems: "center",
                          },
                          "& .MuiInputBase-input": {
                            marginTop: "-4px", // Adjust this value to move the text up
                            fontSize: 15,
                          },
                        }}
                        id="maturityPeriod"
                        options={maturityPeriods}
                        classes={{ option: classes.option }}
                        size="small"
                        name="maturityPeriod"
                        value={formState?.maturityPeriod || ""}
                        getOptionLabel={(option) =>
                          (option !== "" && `${`${option?.value} Days`}`) || ""
                        }
                        loading={vendorLoading}
                        onChange={(event, newValue) => {
                          autocompleteChangeHandler("maturityPeriod", newValue);
                        }}
                        renderInput={(params) => (
                          <TextField
                            // sx={{ input: { color: "#888888" } }}
                            {...params}
                            name=""
                            required
                            value={""}
                            onChange={changeHandler}
                            InputProps={{
                              ...params.InputProps,
                              endAdornment: (
                                <React.Fragment>
                                  {params.InputProps.endAdornment}
                                </React.Fragment>
                              ),
                            }}
                          />
                        )}
                      />
                    </Grid>

                    <Grid></Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            style={{ marginTop: "15px" }}>
            {/* UPDATED: Added disabled state when amount is invalid */}
            <Button
              style={{
                margin: "2px",
              }}
              variant="contained"
              color="secondary"
              type="submit"
              id="proceed"
              // disabled={!formState?.lc_amount || parseFloat(formState?.lc_amount) <= 0}
              onClick={() => {
                setFormState((formState) => ({
                  ...formState,
                  isProceed: true,
                }));
              }}>
              CREATE VF LC
            </Button>
            <Button
              style={{
                margin: "3px 3px 3px 0px",
                color: "white",
                backgroundColor: "#ED1C24",
              }}
              variant="contained"
              color="danger"
              type="submit"
              id="proceed"
              onClick={() => navigate("/vendorfinancingLC")}>
              CANCEL
            </Button>
          </Grid>
        </form>

        {openProceedBtn && (
          <ProceedBtn
            open={openProceedBtn}
            close={() => setOpenProceedBtn(false)}
            submit={confirmNewLcCreation}
            formState={formState}
            message={
              "Are you sure you want to create LC with the provided details?"
            }></ProceedBtn>
        )}

        {successMessage && (
          <CustomSnackbar
            open={successMessage !== ""}
            message={successMessage}
            handleClose={() => setSuccessMessage("")}
            variant="success"
          />
        )}
        {errorMessage && (
          <>
            {" "}
            <Grid container spacing={0}>
              <Grid item>
                <Error
                  titleAccess="Error"
                  className={classes.asterisk}
                  fontSize="small"
                />{" "}
              </Grid>
              <Grid item>
                <Typography className={classes.asterisk} ml={1}>
                  {" "}
                  {errorMessage}
                </Typography>
              </Grid>
            </Grid>
          </>
        )}
      </CardBody>
    </Card>
  );
};
export default NewLc;